import React from 'react';
import { getCountdown } from '../../helper/Countdown';
import { useAppConfig } from '../../context/AppConfigContext';
import useProductPageContent from '../../hooks/useProductPageContent';
import useProductList from '../../hooks/useProductList';
import { memo, useEffect, useState } from 'react';
import Slider from 'react-slick';
import usePageContent from '../../hooks/usePageContent';
import useProductCategoryByStore from '../../hooks/useProductCategoryByStore';
import Nav from 'react-bootstrap/Nav';
import { useParams } from 'react-router-dom';
import SuggestionList from './SuggestionList';
import ProfileStore from './ProfileStore';
import Button from 'react-bootstrap/Button';

const SellerStoreHome = ({ store, storeId, productCategory, onSelectCategory }) => {
    const { lang } = useParams();
    const { config } = useAppConfig();
    const [timeLeft, setTimeLeft] = useState(getCountdown());
    const { fetchPageContent, data, status, error, resetStatus } = usePageContent();
    const [dataPromo, setDataPromo] = React.useState([]);

    const currency = config?.currency === 'USD' ? '$' : config?.currency === 'AUD' ? 'AU$' : 'Rp';

    useEffect(() => {
        if (status === 'idle') {
            fetchPageContent({ type: 'home', field: 'HotDealsToday', language: 'en-US' });
        }

        if (status === 'done') {
            //console.log(data);
            setDataPromo(data === '' ? [] : JSON.parse(data));
        }
        // console.log(data);
        // console.log(status);
    }, [status]);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setTimeLeft(getCountdown());
    //     }, 1000);

    //     return () => clearInterval(interval);
    // }, []);

    //nav pindah kesini

    const [filterCategoryId, setFilterCategoryId] = useState(undefined);
    const [page, setPage] = useState(0);

    // const {
    //     fetchProductCategoryByStore,
    //     data: productCategory,
    //     status: productCategoryStatus,
    //     error: productCategoryError
    // } = useProductCategoryByStore();

    const {
        fetchProductList,
        data: productList,
        total: productListTotal,
        status: productListStatus,
        error: productListError
    } = useProductList();

    // useEffect(() => {
    //     if (store && store.userId) {
    //         fetchProductCategoryByStore(store.userId);
    //     }
    // }, [store]);

    const setSelectedGallery = (id) => {
        setFilterCategoryId(id);
        setPage(0);
    };

    const setAllCategory = () => {
        setFilterCategoryId(undefined);
        setPage(0);
    };

    useEffect(() => {
        if (!storeId) return;
        // console.log("check fetching categoryid", filterCategoryId);
        fetchProductList({
            // categoryIds: keyword ?? filterCategoryId,
            categoryIds: filterCategoryId,
            companyId: storeId,
            // sortBy: sortBy.split("-")[0],
            // sortType: sortBy.split("-")[1],
            skip: 0,
            take: 20
        });
    }, [filterCategoryId, page, storeId]);

    useEffect(() => {
        //console.log(productListStatus);
        if (productListStatus === 'done') {
            // setIsLastPage(page + 1 === Math.ceil(productListTotal / 20));
            // setIsFirstPage(page === 0);
        }
    }, [productListStatus]);

    // console.log("productList data displayed" , productList)

    //nav function

    const itemCount = productList?.length ?? 0;
    const safeSlidesToShow = Math.min(4, itemCount || 1);

    return (
        <section className="newarrivalproducts py-40">
            <div className="container container-md mb-20">
                <div className="section-heading">
                    <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-sm-between gap-2 gap-sm-8">
                        <h5 className="mb-0">You Might Like</h5>
                        <div className="flex-align mr-point gap-16 w-100 w-sm-auto justify-content-start justify-content-sm-end">
                            <Button
                                variant="link"
                                onClick={() => onSelectCategory()}
                                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                            >
                                View All
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="row g-12 mt-3 mt-sm-0">
                    <div className="col-md-12">
                        <SuggestionList product={productList} />
                    </div>
                </div>
            </div>
            <ProfileStore storeId={storeId} store={store} />
        </section>
    );
};

export default SellerStoreHome;
